// Maximum file upload size in megabytes.
// This should match nginx's client_max_body_size.
// All upload paths reference this constant so changing it here
// updates every warning message automatically.
export const MAX_UPLOAD_SIZE_MB = 80;

export const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;

/**
 * Check if a file exceeds the upload limit.
 * Returns a human-readable warning string, or null if within limits.
 */
export function checkFileSize(file: File): string | null {
  if (file.size > MAX_UPLOAD_SIZE_BYTES) {
    const sizeMB = (file.size / (1024 * 1024)).toFixed(1);
    const name = file.name ? `"${file.name}"` : 'This file';
    return `${name} is ${sizeMB} MB, which exceeds the ${MAX_UPLOAD_SIZE_MB} MB upload limit. It will not be uploaded — please choose a smaller file.`;
  }
  return null;
}
